import React from "react";
import AuthLayout from "../components/AuthLayout";
import SuccessResponse from "../reusableComponents/components/generics/SuccessResponse";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PORTAL } from "../utils/constant";

function ResetSuccessMessage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(PORTAL);
    };

    const handleBackButtonClick = () => {
        window.open("https://dev-camu.devopsdemo.live/front/login", "_blank");
    };
    return (
        <div>
            <AuthLayout
                imageTitle={t("titleCreateAccount")}
                imageSubtitle={t("subheadingCreateAccount")}
                buttonName={t("login")}
                accountMsg={t("alreadyAccount")}
                buttonClick={handleClick}
                backButtonClick={handleBackButtonClick}
            >
                <SuccessResponse
                    title={t("PasswordReset")}
                    message={t("ResetMessage")}
                    handleClick={handleClick}
                    ButtonName={t("login")}
                />
            </AuthLayout>
        </div>
    );
}

export default ResetSuccessMessage;
